export default "__VITE_ASSET__$xeZcrPm__"